export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13272.af6b1300.jpg";